import { Component } from 'react';
import RecommendedTopicsContainer from '../RecommendedTopicsContainer';
import RecommendedPages from '../RecommendedPages';
import LowCTR from '../LowCTR';
import { tags } from './keys';
import AnalyzeContent from '../AnalyzeContent';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.showElement = this.showElement.bind(this);
        this.addActive = this.addActive.bind(this);

        this.state = {
            types: ['analyze'],
        };
    }

    onClick(id) {
        if (id === 'all') {
            return this.setState({
                types: tags(this.props.t).map((tag) => tag.id),
            });
        }

        this.setState({
            types: [id],
        });
    }

    showElement(id) {
        return !this.state.types.length || this.state.types.includes(id);
    }

    addActive(id) {
        if (this.state.types.includes('all')) {
            if (id === 'all') return true;
            return false;
        }

        return this.state.types.includes(id);
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="tags-container">
                    {tags(t).map((tag) => (
                        <span
                            className={`tab-item ${this.addActive(tag.id) && 'active-tag'}`}
                            key={tag.id}
                            onClick={() => this.onClick(tag.id)}
                        >
                            {tag.label}
                        </span>
                    ))}
                </div>
                <div
                    style={{
                        display: this.showElement('analyze') ? 'block' : 'none',
                    }}
                >
                    <AnalyzeContent
                        csrf_token={this.props.csrf_token}
                        is_superuser={this.props.is_superuser}
                        domain_id={this.props.domain_id}
                        report_name="pages"
                        all={true}
                    />
                </div>
                <div id="recommendations-content">
                    <div
                        className="row card-row"
                        id="recommendations-page"
                        style={{
                            display: this.showElement('pages') ? 'flex' : 'none',
                        }}
                    >
                        <div className="col-12">
                            <div className="card table-main rounded-main overflow-hidden">
                                <div>
                                    <RecommendedPages
                                        default_image={this.props.default_image}
                                        domain={this.props.domain}
                                        content_id="recommendations-page"
                                        parent_id="recommendations-content"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        id="recommended-topics-container"
                        style={{
                            display: this.showElement('entities') ? 'block' : 'none',
                        }}
                    >
                        <RecommendedTopicsContainer
                            domain={this.props.domain}
                            parent_id="recommendations-content"
                        />
                    </div>
                    <div
                        className="row card-row"
                        id="recommendations-low-ctr"
                        style={{
                            display: this.showElement('lowCTR') ? 'flex' : 'none',
                        }}
                    >
                        <div className="col-12">
                            <LowCTR
                                domain={this.props.domain}
                                content_id="recommendations-low-ctr"
                                parent_id="recommendations-content"
                                default_image={this.props.default_image}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(Summary);
